import * as React from 'react';
import { WithRouterProps, InjectedRouter } from 'react-router';
// @ts-ignore
import Avatar from 'entities/Avatar';
import BoxHeader from 'components/BoxHeader';
import BoxBody from 'components/BoxBody';
import Button from 'components/Button';
import ConfirmDialog from 'components/ConfirmDialog';
// @ts-ignore
import Divider from 'components/Divider';
// @ts-ignore
import Group from 'entities/Group';
// @ts-ignore
import GroupActions from 'groups/actions/GroupActions';
// @ts-ignore
import Link from 'components/Link';
// @ts-ignore
import List from 'components/List';
import MediaObject from 'components/MediaObject';
// @ts-ignore
import ModalTrigger from 'components/ModalTrigger';
import ToastActions from 'actions/ToastActions';
import { mountModal } from 'lib/modal';
import { withRouter } from 'app/context/Router';
// @ts-ignore
import GroupAvatarSelector from './GroupAvatarSelector';
// @ts-ignore
import GroupForm from './GroupForm';
// @ts-ignore
import GroupOptionsForm from './GroupOptionsForm';
// @ts-ignore
import ReuseClassConfirmDialog from './ReuseClassConfirmDialog';
// @ts-ignore
import RemoveClassConfirmationDialog from './RemoveClassConfirmDialog';
// @ts-ignore
import { unaffiliatedOrgOption, UNAFFILIATED_CLASS_ID } from 'groups/components/GroupSchoolSelect';
import TitleHeader from 'components/TitleHeader';

import './styles/GroupEditPanel.scss';

type Props = {
  group: Group;
  onCodeChange: Function;
  userIsTeacher: boolean;
  onRequestHide: Function;
  isSettingsTab?: boolean;
} & WithRouterProps;

type State = {
  name?: string | null;
  code?: string | null;
  canSubmit: boolean;
  group: Group;
  initialCode?: string;
  organizationId?: number | null;
};

class GroupEditPanel extends React.Component<Props, State> {
  state: State = {
    name: null,
    code: null,
    canSubmit: false,
    group: this.props.group,
    organizationId: undefined,
  };

  componentWillMount() {
    const { group } = this.props;
    this.setState({ initialCode: group.getCode() });
  }

  handleAvatarSelected = (avatar: Avatar) => {
    GroupActions.patch(
      this.props.group,
      {
        group_avatar_id: avatar.id,
      },
      'Icon saved'
    );
  };

  handleInvalidChange = () => {
    this.setState({ name: null, code: null, canSubmit: false });
  };

  handleValidChange = (name: string, code: string, orgId?: string) => {
    this.setState({
      name,
      code,
      // TODO -- add a test for this (to avoid future p0s)
      // if the orgId is equal to the UNAFFILIATED_CLASS_ID, then we need to set this key to null,
      // otherwise pass in the org id
      // if the orgId is undefined for some god forsaken reason then use that in the key so that it doesn't get sent to r101-api as null and
      //   remove us from the org
      organizationId:
        orgId !== UNAFFILIATED_CLASS_ID ? (orgId && parseInt(orgId, 10)) || undefined : null,
      canSubmit: true,
    });
  };

  handleOptionsChange = (name: string, value: boolean) => {
    const underscored = name.replace(/([A-Z])/g, a => `_${a.toLowerCase()}`);
    GroupActions.patch(this.props.group, { [underscored]: value }).then(
      (group: any) => this.setState(group),
      ({ message }: { message: any }) => {
        this.setState({ group: this.props.group });
        ToastActions.showErrorToast(message);
      }
    );
  };

  handleSubmit = () => {
    const { code, name, organizationId } = this.state;

    if (!code) {
      throw new Error('missing group code in handleSubmit');
    }

    const attributes = {
      name: code,
      class_name: name,
      // @ts-ignore
      group_avatar_id: this.refs.avatarSelector.getSelectedAvatarId(),
      organization_id: organizationId,
    };

    const update = () => {
      GroupActions.patch(this.props.group, attributes).then(
        () => {
          this.props.onRequestHide();
          if (this.state.initialCode !== code) {
            this.props.onCodeChange(code);
          }
        },
        (error: any) => ToastActions.showAPIError(error)
      );
    };

    if (attributes.name === this.props.group.getCode()) {
      update();
    } else {
      mountModal(
        this.renderConfirmDialog(
          `Are you sure you want to change your class code to @${attributes.name}`,
          'Current participants won’t be affected, but new participants ' +
            'must use this code to join your class.',
          'No',
          'Yes',
          update
        ),
        this
      );
    }
  };
  renderConfirmDialog(
    title: string,
    note: string,
    cancelButtonText: string,
    actionButtonText: string,
    onConfirm: () => void
  ) {
    return (
      <ConfirmDialog
        eventScreenName="GroupEditPanel"
        glyph="caution"
        glyphColor="lava"
        title={title}
        actionButtonText={actionButtonText}
        cancelButtonText={cancelButtonText}
        onConfirm={onConfirm}
        subtext={note}
      />
    );
  }

  render() {
    const { isSettingsTab, group, router, onRequestHide } = this.props;
    const reuseClassButton = renderReuseClassButton(group, router, onRequestHide);
    const removeClassButton = renderRemoveClassButton(group, router, onRequestHide);
    const archiveSection = !!isSettingsTab === false &&
      (removeClassButton || reuseClassButton) && (
        <div>
          <Divider size="medium" />
          <List size="small" className="archiveSection">
            {reuseClassButton}
            {removeClassButton}
          </List>
        </div>
      );
    const currentOrg = this.props.group.getOrganization();
    const currentOrgOption = currentOrg
      ? {
          value: currentOrg.id.toString(),
          label: currentOrg.getName(),
        }
      : unaffiliatedOrgOption;

    const getClassAvatar = () => (
      <div className={isSettingsTab ? 'GroupEditPanel-left-avatar' : 'GroupEditPanel-avatar'}>
        <GroupAvatarSelector
          ref="avatarSelector"
          onSelect={this.handleAvatarSelected}
          initialAvatar={this.props.group.getAvatar()}
          horizontal={isSettingsTab}
        />
      </div>
    );

    const getClassFields = () => (
      <div>
        <GroupForm
          group={this.state.group}
          name={this.props.group.getName()}
          code={this.props.group.getCodeOrError()}
          currentOrganization={currentOrgOption}
          onFormValid={this.handleValidChange}
          onFormInvalid={this.handleInvalidChange}
          autofocus={false}
        />
        <Button
          className="GroupEditPanel-submit"
          disabled={!this.state.canSubmit}
          onClick={this.handleSubmit}
          eventElementName="GroupEditPanel-submit"
          data-test-selector="group-edit-submit">
          Save
        </Button>
      </div>
    );

    const getChildContent = () => {
      const children = (isSettingsTab && (
        <div>
          {getClassAvatar()}
          <br />
          {getClassFields()}
        </div>
      )) || <MediaObject children={[getClassAvatar(), getClassFields()]} />;

      const { group } = this.props;

      return (
        <React.Fragment>
          <BoxBody className="GroupEditPanel">{children}</BoxBody>
          <BoxBody flush>
            <Divider size="flush" />
          </BoxBody>

          <BoxHeader title="Class settings" textAlign="left" />
          <BoxBody className="GroupEditPanel">
            <GroupOptionsForm
              hasChildren={group.hasChildren()}
              hideUnderageNote={!group.getOrganization()}
              searchable={group.isSearchable()} // old
              showClassSearchability={!group.hasStudentOrParentOwner()}
              userIsTeacher={this.props.userIsTeacher}
              onChange={this.handleOptionsChange}
              groupUuid={group.getUuid()}
            />
            {archiveSection}
          </BoxBody>
          <BoxBody flush>
            <Divider size="flush" />
          </BoxBody>
        </React.Fragment>
      );
    };

    return getChildContent();
  }
}

const renderActionContent = (
  actionText: string,
  description: string,
  dataTestSelector: string = '',
  isButton?: boolean,
  titleText?: string
) => {
  const descComp = <TitleHeader flush textAlign="left" title={titleText} subtext={description} />;
  const getButtonAction = () => (
    <Button color="lava" level="secondary" data-test-selector={dataTestSelector}>
      {actionText}
    </Button>
  );
  const getLinkAction = () => (
    <Link color="lava" block data-test-selector={dataTestSelector}>
      {actionText}
    </Link>
  );

  return isButton ? (
    <div>
      {descComp}
      <br />
      {getButtonAction()}
    </div>
  ) : (
    <div>
      {getLinkAction()}
      <div className="GroupEditPanel-subtext">{description}</div>
    </div>
  );
};

export const renderReuseClassButton = (
  group: Group,
  router: InjectedRouter,
  onRequestHide: Function,
  button?: boolean
) => {
  if (group.canEdit()) {
    return (
      <ModalTrigger
        modal={
          <ReuseClassConfirmDialog
            group={group}
            onSubmit={onRequestHide}
            onActionCompletion={(newGroup: any) =>
              router.push(`/classes/${newGroup.getCodeOrError()}`)
            }
            subText={`A new class will be created with the code @${group.getCodeOrError()}. You can always view and restore archived classes from your settings.`}
            archiveFirst
          />
        }>
        {renderActionContent(
          'Reuse class code',
          'Archive this class and create a new class with the same class code.',
          '',
          button,
          'Reuse class code'
        )}
      </ModalTrigger>
    );
  }
  return null;
};

export const renderRemoveClassButton = (
  group: Group,
  router: InjectedRouter,
  onRequestHide: Function,
  button?: boolean
) => {
  if (group.canEdit()) {
    const handleRemoveCompletion = () => {
      onRequestHide();
      router.push('/classes');
    };

    const renderRemoveDialog = () => {
      return (
        <RemoveClassConfirmationDialog group={group} onActionCompletion={handleRemoveCompletion} />
      );
    };

    return (
      <ModalTrigger modal={renderRemoveDialog()}>
        {renderActionContent(
          'Archive Class',
          'Archive this class and it will no longer appear in your class list.',
          'group-remove-class-button',
          button,
          'Remove class'
        )}
      </ModalTrigger>
    );
  }
  return null;
};

export { GroupEditPanel };

export default withRouter(GroupEditPanel);
